import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ConnectWithUs from "./sections/ConnectWithUs";
import WhereToFindUs from "./sections/WhereToFindUs";
import BrandFootnote from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ConnectWithUs />
      <WhereToFindUs />
      <BrandFootnote />
    </div>;
}